import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IProduct } from 'src/app/models/products/product';
import { IMasterSuite } from 'src/app/models/mastersuites/mastersuite';

@Component({
  selector: 'app-product-actions-dropdown',
  templateUrl: './product-actions-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ProductActionsDropdownComponent {
  @Input() selectedProducts: IProduct[] = [];
  @Input() masterSuites: IMasterSuite[] = [];
  @Input() organizationId = '';
  @Input() batchId = '';
  @Output() actionComplete = new EventEmitter<void>();

  sectionVisible: Record<string, boolean> = {};

  get hasAnyPermission(): boolean {
    return Object.values(this.sectionVisible).some((v) => v);
  }

  onChildVisibility(section: string, visible: boolean): void {
    if (visible) this.sectionVisible[section] = true;
  }
}
